export * from '@wix/error-monitor/react';
//# sourceMappingURL=ErrorMonitor.js.map